import { render, staticRenderFns } from "./roleUserData.vue?vue&type=template&id=6206af90&scoped=true&"
import script from "./roleUserData.vue?vue&type=script&lang=js&"
export * from "./roleUserData.vue?vue&type=script&lang=js&"
import style0 from "./roleUserData.vue?vue&type=style&index=0&id=6206af90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6206af90",
  null
  
)

export default component.exports